import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { registerAlumni } from '../services/authService';
import './Register.css';

const initialForm = {
  fullName: '',
  email: '',
  password: '',
  passwordConfirmation: ''
};

export default function Register() {
  const [form, setForm] = useState(initialForm);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const nav = useNavigate();

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');

    if (form.password !== form.passwordConfirmation) {
      setError('Password and confirm password do not match.');
      return;
    }

    try {
      const res = await registerAlumni(form);
      setMessage(res?.message || 'Verification code sent to your email.');
      nav(`/verify-email?email=${encodeURIComponent(form.email)}`, { replace: true });
    } catch (err) {
      const nextMessage = String(err?.message || '');
      if (/unable to send verification email right now/i.test(nextMessage)) {
        nav(`/verify-email?email=${encodeURIComponent(form.email)}`, {
          replace: true,
          state: {
            notice:
              'Registration request was received, but email delivery failed. Please use "Resend code" below.'
          }
        });
        return;
      }
      setError(nextMessage || 'Registration failed.');
    }
  };

  return (
    <div className="register-page">
      <div className="register-card">
        <div className="register-brand">
          <div>
            <p className="register-eyebrow">SFACO-CTG</p>
            <h1>Alumni self-registration</h1>
            <p className="register-subtitle">
              Register with your email, verify the code, and then login to access your dashboard.
            </p>
          </div>
          <div className="register-highlight">
            <p>Account is created only after email code verification.</p>
          </div>
        </div>

        <form className="register-form" onSubmit={submit}>
          <label>
            Full name
            <input
              type="text"
              value={form.fullName}
              onChange={(e) => setForm({ ...form, fullName: e.target.value })}
              required
            />
          </label>

          <label>
            Email address
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
            />
          </label>

          <label>
            Password
            <div className="password-input-wrap">
              <input
                type={showPassword ? 'text' : 'password'}
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </label>

          <label>
            Confirm password
            <div className="password-input-wrap">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                value={form.passwordConfirmation}
                onChange={(e) => setForm({ ...form, passwordConfirmation: e.target.value })}
                required
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
                aria-label={showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'}
              >
                {showConfirmPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </label>

          {error && <p className="register-error">{error}</p>}
          {message && <p className="register-message">{message}</p>}

          <button type="submit" className="register-submit">Submit registration</button>

          <p className="register-footnote">
            Already have an account? <Link to="/login">Sign in</Link>
          </p>
          <Link className="back-home" to="/">Back to home</Link>
        </form>
      </div>
    </div>
  );
}
